import React, { FC } from 'react';
import { Theme, Box, Typography, makeStyles, Container } from '@material-ui/core';

interface StrokeSectionProps {
  text: string;
}

const useStyles = makeStyles((theme: Theme) => ({
  background: {
    marginTop: theme.spacing(20),
    padding: theme.spacing(8, 0),
    backgroundColor: theme.palette.background.paper,
    borderBottom: `1px solid ${theme.palette.primary.main}`,
  },
  text: {
    fontWeight: 300,
    color: theme.palette.common.white,
  },
}));

const StrokeSection: FC<StrokeSectionProps> = ({ text }) => {
  const classes = useStyles();
  return (
    <Box className={classes.background}>
      <Container fixed>
        <Typography variant="h5" className={classes.text} align="center" data-aos="fade-zoom-in">
          {text}
        </Typography>
      </Container>
    </Box>
  );
};

export default StrokeSection;
